<template>
	<div class="row">
		<div class="col-sm-8">
			<aBox title="Modelo de documentos">
				<div slot="tools">
					<aBtn
						text="Documentos"
						icon="plus"
						size="sm"
						type="success"
						@click="$refs.mdNewDoc.open()"
					/>
				</div>
				<div slot="body">
					<sTable
						ref="table"
						actionRead="private-read-modDocs"
						actionDelete="private-delete-modDocs"
						:labels="labels"
						:actions="actions"
						:functions="func"
						@edit="(data) => $refs.mdNewDoc.open(data)"
						@preview="(pay) => dowload_document(pay)"
					/>
				</div>
			</aBox>
		</div>
		<div class="col-sm-4">
			<aBox title="Dicionário" no-padding>
				<div slot="body">
					<div class="col-sm-12 color-search">
						<br />
						<div class="input-group">
							<input
								type="text"
								v-model="filter"
								placeholder="Pesquisar"
								class="form-control"
							/>
							<span class="input-group-addon">
								<i class="fa fa-search"></i>
							</span>
						</div>
						<div class="clearfix"></div>
						<br />
					</div>
					<ul class="list-group">
						<li v-for="(item, id) in fiterReplaceMethods" :key="id">
							<div>{{ item }}</div>
							<b>{{ `\$\{${id}\}` }}</b>
						</li>
					</ul>
				</div>
			</aBox>
		</div>
		<modalNewDoc
			ref="mdNewDoc"
			@update="$refs.table.updateTable()"
			:assets="assets"
		/>
		<!-- <modalPreview ref='mdPreview' /> -->
	</div>
</template>
<script>
	import aBox from 'box';
	import aBtn from 'btn';
	import sTable from 'table';
	import modalNewDoc from './components/modal-new-document.vue';
	// import modalPreview from './components/modal.preview.vue'
	import WBS from 'js/http';

	export default {
		name: 'manageDocs',
		components: {
			aBox,
			aBtn,
			sTable,
			modalNewDoc,
			// modalPreview
		},
		data() {
			return {
				labels: [
					{ data: 'cod', label: 'Cod' },
					{ data: 'titulo', label: 'Titulo' },
					{ data: 'modalidade', label: 'Modalidade' },
					{ data: 'deptos', label: 'Deptos' },
				],
				actions: [
					'delete',
					'edit',
					{
						emit: 'preview',
						color: 'btn-warning',
						icon: 'fa-download',
						text: '',
					},
				],
				func: [{ cod: 'deptos', fx: this.tag_transform }],
				list: [],
				filter: '',
				assets: {
					deptos: [],
				},
			};
		},
		// provider(){
		// 	const assets = {}
		// 	Object.defineProperty(assets, 'deptos', {
		// 		enumerable: true,
		// 		get: e => this.assets.deptos
		// 	})
		// 	return { assets }
		// },
		computed: {
			fiterReplaceMethods() {
				let resp = {};
				for (let it in this.list) {
					if (
						this.list[it]
							.toLowerCase()
							.indexOf(this.filter.toLowerCase()) != -1
					) {
						resp[it] = this.list[it];
					}
				}
				return resp; //.filter( i=> i.indexOf( this.filter.toLowerCase() ) != -1 )
			},
		},
		methods: {
			tag_transform(data) {
				if (data.length == 0)
					return '<span class="label label-warning">Todos</span>';
				else
					return data.reduce((resp, item) => {
						var text = this.assets.deptos.find(
							(i) => i.cod == item
						);
						return (
							resp +
							('<span class="label label-primary">' +
								text.titulo +
								'</span>')
						);
					}, '');
			},
			copy(id) {
				this.$refs.replaces[id].select();
				document.execCommand('copy');
			},
			dowload_document(pay) {
				let path =
					'http://wbs.viasst.com.br/uploaded_files/models_documents/';
				window.open(path + pay.link.file, '_blank');
			},
		},
		mounted() {
			WBS.send('protected-custom-replaceDocument:getIndex', (resp) => {
				if (resp.status == 'success' && resp.data != undefined) {
					this.list = resp.data;
				}
			});
			WBS.send('protected-read-assetsModDocs', (resp) => {
				if (resp.status == 'success') {
					this.assets = resp.data;
				}
			});

			this.$emit('setHeader', ['Modelos de Documentos', '']);
		},
	};
</script>
<style scoped>
	.list-group li {
		padding: 10px;
		border-bottom: 1px solid #cecece;
	}
	.list-group div {
		font-size: 12px;
		display: block;
		margin: 0 0 -5px 0;
	}

	.color-search {
		background-color: #eee;
	}
	input.list-group-item {
		cursor: pointer;
		width: 100%;
	}
	input.list-group-item:hover {
		color: #31708f;
		background-color: #d9edf7;
	}
	.list-group {
		margin-bottom: 0px;
		border-radius: 0px;
		max-height: calc(100vh - 260px);
		overflow: auto;
		float: left;
		width: 100%;
	}
	.list-group-item:first-child {
		border-top-left-radius: 0px;
		border-top-right-radius: 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/models/documents/index.vue